export default __webpack_public_path__ + "static/media/select-radio-active-colored.5d53c28a.svg";